<template>
  <div id="app">
    <div id="share_main">
      <van-row>
        <van-col span="24"
          >中控大师授权码分享<br />http://fx.hondamaster.cn
        </van-col>
      </van-row>
      <van-row class="main_row">
        <van-col span="24"
          ><van-button type="primary" @click="getCode"
            >获取新的授权码</van-button
          ></van-col
        >
      </van-row>

      <van-row class="main_row">
        <van-col span="24"
          ><van-button type="info" @click="showMyCode"
            >查看我已经分享的授权码</van-button
          ></van-col
        >
      </van-row>

      <van-row class="main_row">
        <van-col span="24"
          >自己的授权码，请在车上查看 <br/>
          打开中控大师，依次点击：更多功能-->其他</van-col
        >
      </van-row>
    </div>
    <van-row>
      <van-col span="24">
        <p>
          @2021 HondaMaster.cn <br />
          Created By Mark
        </p>
      </van-col>
    </van-row>

    <van-popup v-model="show" position="top" class="overlay80vh">
      <van-row>
        <van-col span="24" class="data_row"><b>我的专属分享授权码</b><br/>http://fx.hondamaster.cn</van-col>
      </van-row>
      <van-row>
        <van-col span="24"><hr /></van-col>
      </van-row>
      <van-row style="padding-bottom: 10px">
        <van-col span="24" class="data_row"
          ><b>{{my_active_code}}<br/>您总共已经分享成功：<font color="#F4A460">{{ share_total }}</font> 个</b></van-col
        >
      </van-row>
      <van-row>
        <van-col span="24" class="data_row"
          ><b>最新分享的几个如下：</b></van-col
        >
      </van-row>
      <van-row v-for="item in dataList" :key="item.id">
        <van-col class="data_row" span="24" v-if="item.active_status == 0"
          >授权码：<font color="#00CED1">{{ item.active_code }}</font>
          (未使用)</van-col
        >
        <van-col class="data_row" span="24" v-else
          >授权码：<font color="#F4A460">{{ item.active_code }}</font>
          (已使用)</van-col
        >
      </van-row>
    </van-popup>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      my_active_code: "",
      share_total: 0,
      dataList: [],
      show: false,
    };
  },

  methods: {
    getCode() {
      var code = prompt("请输入您的授权码");
      if (code == null || code.length != 10) {
        this.$toast.fail("授权码码错误");
        return;
      }

      axios
        .get(
          "api/gen_code?key="+code)
        .then((res) => {
          if (res.data.code == 0) {
            this.$toast.success(res.data.message);
          }else{
            this.$toast.fail(res.data.message);
          }
        });

    },

    showMyCode() {
      var code = prompt("请输入您的授权码");
      if (code == null || code.length != 10) {
        this.$toast.fail("授权码码错误");
        return;
      }

      axios
        .get(
          "api/my_code?key="+code)
        .then((res) => {
          if (res.data.code == 0) {
            var reg=/^(\d{3})\d{4}(\d{3})$/;
            this.my_active_code = code.replace(reg, "$1****$2");
            this.show = true;
            this.dataList = res.data.data.data_list;
            this.share_total = res.data.data.share_total;
          }else{
            this.$toast.fail(res.data.message);
          }
        });
     
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.overlay80vh{
  height: 80vh;
}
#share_main {
  padding: 10px;
}
.main_row {
  margin-top: 30px;
}
.data_row {
  text-align: left;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
